import {createSlice} from "@reduxjs/toolkit";


export const pianificazioniStore = createSlice({
    name: 'pianificazioni',
    initialState: {
        pianificazioneForUpdate: null,
        pianificazioniConflitti: null,
        erroriPianificazione: null
    },
    reducers: {
        pianificazioniInit(state) {
            state.pianificazioneForUpdate = null;
            state.pianificazioniConflitti = null;
            state.erroriPianificazione = null;
        },
        addPianificazioneFail(state, action) {
            state.erroriPianificazione = action.payload;
        },
        setPianificazioneToUpdate(state, action) {
            state.pianificazioneForUpdate = action.payload;
        },
        pianificazioniEsclusioneFail(state, action) {
            state.erroriPianificazione = action.payload;
        },
        pianificazioniConflittiSuccess(state, action) {
            state.pianificazioniConflitti = action.payload;
        }
    }
});

export const pianificazioniActions = pianificazioniStore.actions;
